module.exports = __webpack_public_path__ + "static/media/MPratings.c4f8abbb.md";